import { render, staticRenderFns } from "./BulletinsTrimestre.vue?vue&type=template&id=408afa45&"
import script from "./BulletinsTrimestre.vue?vue&type=script&lang=js&"
export * from "./BulletinsTrimestre.vue?vue&type=script&lang=js&"
import style0 from "./BulletinsTrimestre.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports